@if (isLoading) {
  <p class="text-xs mt--none mb--sm" aria-hidden="true">&nbsp;</p>
} @else if (comparisonPeriod) {
  <p class="text-xs color--dark-blue-grey mt--none mb--sm align-right">
    {{ 'App.Admin.Dashboard.Labels.ComparedTo' | translate:{ range: comparisonLabel } }}
  </p>
}
